export default "__VITE_ASSET__DCX_jD6h__"